import { useTranslation } from "react-i18next"

import { ROUTES_CONFIG } from "@/constants"
import { constructUrl } from "@/utils/constructUrl"
import { FEATURE_FLAG, useFeature } from "@/utils/featureFlag"
import { openWindow } from "@/utils/openWindow"

export const AdminButton = () => {
  const { t } = useTranslation()
  const canUseAdmin = useFeature(FEATURE_FLAG.ADMIN)

  const onClick = () =>
    openWindow({
      url: `${constructUrl(ROUTES_CONFIG.admin)}?${FEATURE_FLAG.ADMIN}`,
      name: "Reactive Trader Admin",
      width: 320,
      height: 400,
    })

  return canUseAdmin ? (
    <div>
      <button
        onClick={onClick}
        className="fas fa-cog"
        title={t("admin.openAdmin")}
      />
    </div>
  ) : null
}
